import { useT } from '@/i18n/useT';

/**
 * The $mallX brand lockup — the real logo (public/logo.png, the robotic-face
 * mark shared with the operator dashboard) in its neon halo, beside the gradient
 * wordmark + tagline. `size="sm"` is the compact top-bar variant.
 */
export function Brand({ size = 'lg' }: { size?: 'lg' | 'sm' }) {
  const { t } = useT();
  return (
    <div className={`brand ${size === 'sm' ? 'brand-sm' : ''}`}>
      <span className="brand-logo-wrap">
        <img className="brand-logo" src="/logo.png" alt={t('brand.name')} width={76} height={76} />
      </span>
      <span className="brand-text">
        <span className="brand-name">{t('brand.name')}</span>
        <span className="brand-tag">{t('brand.tagline')}</span>
      </span>
    </div>
  );
}
